var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin-stop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 20 0 20 26 0 26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-stop"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0017179,0 C4.49063735,0 0,4.53775224 0,10.1109181 C0,14.172658 2.42226422,17.9772818 4.75863254,20.8125084 C7.09500086,23.6477349 9.43136918,25.5378859 9.43136918,25.5378859 L10.0017179,26 L10.5720667,25.5378859 C10.5720667,25.5378859 12.908435,23.6477349 15.2448033,20.8125084 C17.5811716,17.9772818 20,14.172658 20,10.1109181 C20,4.53775224 15.5127985,0 10.0017179,0",
    id: "Fill-1",
    fill: "#D8232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0869565,6 L6.91304348,6 C6.41304348,6 6,6.41304348 6,6.91304348 L6,13.0869565 C6,13.5869565 6.41304348,14 6.91304348,14 L13.0869565,14 C13.5869565,14 14,13.5869565 14,13.0869565 L14,6.91304348 C14,6.41304348 13.5869565,6 13.0869565,6 Z",
    id: "Shape-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinStop);
export default __webpack_public_path__ + "static/media/pin-stop.38baca5c9f96139d128b5734eea8b186.svg";
export { ForwardRef as ReactComponent };